
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import LabelRepository from '@/repositories/content/label/LabelRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class LabelFormScreen extends Vue {
    @Inject()
    private readonly labelRepository!: LabelRepository;
}
